import React from 'react';
import { withTranslation } from 'react-i18next';
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../../scss/main.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { parseQueryParameters } from '../../utils/queryStringHandler';
import Auth from '../Auth/Auth';
import LoadPage from '../LoadPage/LoadPage';
import { withRouter } from '../../utils/withRouter';

class Home extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      authenticated: false
    }
    parseQueryParameters();
  }

  componentDidMount() {
    this.setState({
      ...this.state, 
      authenticated: sessionStorage.getItem('isVerified')
    });
  }

  authenticate = () => {
    this.setState({
      ...this.state,
      authenticated: true
    })
  }

  render() {
    const { t } = this.props;
    const enableAuth = import.meta.env.VITE_ENABLE_AUTH==='true';
    return (      
      <div className="body">
        <HelmetProvider>
        <Helmet htmlAttributes={{ lang: t("language") }}>
          <title>{t("metaTags#pageTitle")}</title>
          <meta name="keywords" content={t("metaTags#keywords")} />
          <meta name="description" content={t("metaTags#metaDescription")} />
          <link rel="canonical" href={t("canonicalURL")}/>
        </Helmet>
        </HelmetProvider> 
        {!this.state.authenticated && enableAuth ? 
          <Auth authenticate={this.authenticate}/>
        : <LoadPage locale={this.props.match.params.localeName}/>}
      </div>
    );
  }
}


export default withTranslation()(withRouter(Home));
